import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";
import type { ChartOptions } from "chart.js";
import { Bar } from "react-chartjs-2";
import type { EpicLeaderboardDistributionBucket } from "../../types/epicLeaderboard";
import { getEpicColor } from "../../utils/epicColors";
import { formatSeconds } from "./format";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

type Props = {
  epicName: string;
  distribution: EpicLeaderboardDistributionBucket[];
};

const EpicDistributionChart = ({ epicName, distribution }: Props) => {
  const color = getEpicColor(epicName);

  const options: ChartOptions<"bar"> = {
    responsive: true,
    maintainAspectRatio: true,
    scales: {
      x: {
        ticks: { color: "rgb(199, 238, 255)", maxRotation: 60 },
        grid: { color: "rgb(70, 130, 180)" }
      },
      y: {
        beginAtZero: true,
        ticks: { color: "rgb(199, 238, 255)", precision: 0 },
        grid: { color: "rgb(70, 130, 180)" }
      }
    },
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          title: (items) => {
            const bucket = distribution[items[0].dataIndex];
            return `${formatSeconds(bucket.bucketStartSeconds)} - ${formatSeconds(
              bucket.bucketEndSeconds
            )}`;
          },
          label: (ctx) => `${ctx.parsed.y} runs`
        }
      }
    }
  };

  return (
    <Bar
      options={options}
      data={{
        labels: distribution.map((b) => formatSeconds(b.bucketStartSeconds)),
        datasets: [
          {
            label: "Runs",
            data: distribution.map((b) => b.runs),
            borderColor: color,
            backgroundColor: `${color}cc`
          }
        ]
      }}
    />
  );
};

export default EpicDistributionChart;
